import { Select, SelectProps } from "antd";
import { BaseOptionType } from "antd/es/cascader";
import { DefaultOptionType } from "antd/es/select";
import { valueType } from "antd/es/statistic/utils";
import SelectDropdownLgIcon from "../../assets/icons/SelectDropdownLgIcon";
import IMG from "../../assets/images/avatar.svg";
import { GetAllUsersDataType } from "../../types/portal/user";
import UserWithImageNameTitle from "./UserWithImageNameTitle";

const { Option } = Select;

interface SelectImgNameTitleProps
  extends SelectProps<valueType, BaseOptionType | DefaultOptionType> {
  data?: GetAllUsersDataType["data"]["users"];
}

export default function SelectImgNameTitle({
  data,
  ...rest
}: SelectImgNameTitleProps) {
  console.log(data);
  const customRender = (id: number) => {
    const user = data?.find((user) => user?.id === id);

    if (!user) return null;

    return (
      <UserWithImageNameTitle
        img={IMG}
        name={user?.name}
        title={user?.department?.name}
      />
    );
  };

  return (
    <Select
      style={{ width: "100%" }}
      optionLabelProp="label"
      rootClassName="select-user-with-image"
      allowClear
      suffixIcon={<SelectDropdownLgIcon />}
      {...rest}
    >
      {data?.map((user) => (
        <Option key={user.id} value={user.id} label={customRender(user.id)}>
          <UserWithImageNameTitle
            img={IMG}
            name={user?.name}
            title={user?.department?.name}
          />
        </Option>
      ))}
    </Select>
  );
}
